// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"WarehouseModalComponent_modalBody__1owEf","modalFooter":"WarehouseModalComponent_modalFooter__2AFYb","highlight":"WarehouseModalComponent_highlight__nUj4w"};